import React from "react";
import { Input, Label, ComboBox, ComboBoxItem } from "@ui5/webcomponents-react";

const SocioeconomicForm3 = ({ formData, onFormChange, handlePrevious, handleNext }) => {
  // Define the options with corresponding numbers
  const houseLocationOptions = [
    { value: 1, label: "1 - Along estero/creek/waterways" },
    { value: 2, label: "2 - Along river banks/shoreline" },
    { value: 3, label: "3 - Along railroad" },
    { value: 4, label: "4 - In the garbage dumpsite" },
    { value: 5, label: "5 - Under the bridge" },
    { value: 6, label: "6 - In danger areas such as cliff, hillside, or mountain slopes" },
    { value: 7, label: "7 - In Temporary or permanent relocation area" },
    { value: 8, label: "8 - In a structure without roof/wall or in a housing unit with light materials in its roof and/or walls" },
    { value: 9, label: "9 - In government land without legally recognizable claims to the land" },
    { value: 10, label: "10 - In private land which they do not own" },
    { value: 99, label: "99 - Others, specify" },
  ];

  const ecologicalSettingOptions = [
    { value: 1, label: "1 - Coastal" },
    { value: 2, label: "2 - Lowland" },
    { value: 3, label: "3 - Upland" },
  ];

  const buildingPermitOptions = [
    { value: 1, label: "1 - Oo" },
    { value: 2, label: "2 - Hindi" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  const houseBuiltBefore1990Options = [
    { value: 1, label: "1 - Oo, pero naipaayos na" },
    { value: 2, label: "2 - Oo, pero hindi pa naipaayos" },
    { value: 3, label: "3 - Hindi" },
    { value: 4, label: "4 - Hindi Alam" },
  ];

  const houseAffectedByDisasterOptions = [
    { value: 1, label: "1 - Oo, pero naipaayos na" },
    { value: 2, label: "2 - Oo, pero hindi pa naipaayos" },
    { value: 3, label: "3 - Hindi" },
    { value: 4, label: "4 - Hindi Alam" },
  ];

  const houseShapeOptions = [
    { value: 1, label: "1 - Regular" },
    { value: 2, label: "2 - Irregular" },
    { value: 3, label: "3 - Hindi Alam" },
  ];

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
      <h2>Step 4: Disaster Risk Reduction and Management</h2>

      {/* C1. Location of the House */}
      <h3>C1. Location of the House</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Location</Label>
      <ComboBox
        value={houseLocationOptions.find(option => option.value === formData.houseLocation)?.label || ""}
        onChange={(e) => {
          const selectedValue = houseLocationOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("houseLocation", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseLocationOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.houseLocation === 99 && (
        <Input
          name="houseLocationOther"
          value={formData.houseLocationOther || ""}
          onInput={(e) => onFormChange("houseLocationOther", e.target.value.toUpperCase())}
          placeholder="Specify other house location"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* C2. Ecological Setting of the House */}
      <h3>C2. Ecological Setting of the House</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Ecological Setting</Label>
      <ComboBox
        value={ecologicalSettingOptions.find(option => option.value === formData.ecologicalSetting)?.label || ""}
        onChange={(e) => {
          const selectedValue = ecologicalSettingOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("ecologicalSetting", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {ecologicalSettingOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>

      {/* C3. Building Permit */}
      <h3>C3. Ang bahay ba na kasalukuyang tinitirahan ay may aprubadong building permit mula sa LGU?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Building Permit Status</Label>
      <ComboBox
        value={buildingPermitOptions.find(option => option.value === formData.buildingPermit)?.label || ""}
        onChange={(e) => {
          const selectedValue = buildingPermitOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("buildingPermit", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {buildingPermitOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>

      {/* C4. House Built Before 1990 */}
      <h3>C4. Ginawa ba ang bahay na kasalukuyan niyong tinitirhan bago mag-1990?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Built Status</Label>
      <ComboBox
        value={houseBuiltBefore1990Options.find(option => option.value === formData.houseBuiltBefore1990)?.label || ""}
        onChange={(e) => {
          const selectedValue = houseBuiltBefore1990Options.find(option => option.label === e.target.value)?.value || null;
          onFormChange("houseBuiltBefore1990", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseBuiltBefore1990Options.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>

      {/* C5. House Affected by Disaster */}
      <h3>C5. Ang bahay ba na kasalukuyan niyong tinitirhan ay nasira/naapektuhan ng mga nakaraang lindol o ibang kalamidad?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Disaster Impact Status</Label>
      <ComboBox
        value={houseAffectedByDisasterOptions.find(option => option.value === formData.houseAffectedByDisaster)?.label || ""}
        onChange={(e) => {
          const selectedValue = houseAffectedByDisasterOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("houseAffectedByDisaster", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseAffectedByDisasterOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>

      {/* C6. House Shape */}
      <h3>C6. Ano ang hugis ng bahay?</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Shape</Label>
      <ComboBox
        value={houseShapeOptions.find(option => option.value === formData.houseShape)?.label || ""}
        onChange={(e) => {
          const selectedValue = houseShapeOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("houseShape", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseShapeOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
    </div>
  );
};

export default SocioeconomicForm3;